import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ApiConnectionService } from 'src/app/services/api-connection.service';

declare const $: any;

@Component({
  selector: 'app-construction-companies-list',
  templateUrl: './construction-companies-list.component.html',
  styleUrls: ['./construction-companies-list.component.css']
})
export class ConstructionCompaniesListComponent implements OnInit, AfterViewInit {

  featuredCompanies: any = [];
  companies: any = [];

  constructor(
    protected http: ApiConnectionService,
  ) { }

  ngOnInit(): void {
    this.get();
  }

  ngAfterViewInit(): void {
    $('.carousel').owlCarousel({
      autoHeight: false,
      autoplay:true,
      autoplayTimeout:5000,
      autoplayHoverPause:false,
      nav: true,
      dots: false,
      loop: true,
      margin: 10,
      items: 1,
    });

    this.featuredCompanies = [1,2,3,4,5,6]

  }

  get(){
    this.http.getData('profiles/empresas-constructoras?paginate=100',{auth:false}).subscribe(
      (response) => {
        this.companies = response.data
      },
      (error) => {
        console.error(error)
      }
    );
  }

}
